import { render } from "./MarketingGroupDatatableActions.vue?vue&type=template&id=37a75139"
import script from "./MarketingGroupDatatableActions.vue?vue&type=script&lang=js"
export * from "./MarketingGroupDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__